import styled from 'styled-components';
import { CaptionRegularM, DefaultButton, DefaultInput } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';
import ErrorMessageIcon from '@/assets/icons/errorMsgIcon.svg?react';

export const SearchBoxCont = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SearchButton = styled(DefaultButton)`
  width: 111px;
  height: 48px;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.primary[100]};
    border-radius: ${theme.layout.spacing.mikro};
    color: ${theme.colors.primary[100]};
  `};

  svg {
    position: relative;
    top: 2px;
    height: 16px;
    margin: 0 10px 0 0;
  }
`;

export const SearchInput = styled(DefaultInput)`
  margin: 0 16px 0 0;
`;

export const SearchInputCont = styled.div`
  position: relative;
`;

export const SearchInputIcon = styled.span`
  position: absolute;
  top: 15px;
  left: 12px;
`;

// TODO: at least for now i'm duplicating some styles, which I want to refactor later
// here is list of files where I found similar components
// Input.styles.tsx:24 ErrorMsg
// SearchDropdown.styles.tsx:128 ErrorMsg
// SearchStaticHeader.styles.tsx:96 ErrorMessage
// TextArea.styles.tsx:87 TextErrorMessage
export const ErrorMsgCont = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  align-items: flex-start;
  text-align: start;
  ${({ theme }: IThemeProvider) => `
    padding: ${theme.layout.spacing.nano} 0;
  `};
`;

export const ErrorMsgIcon = styled(ErrorMessageIcon)`
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  position: relative;
  top: 2px;
`;

export const ErrorMsg = styled(CaptionRegularM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.support.orange[100]};
    margin-left: ${theme.layout.spacing.nano};
  `};
`;
